const angular = require('angular');

function ButtonLoadIconDirective() {
    return {
        restrict: 'E',
        template: require('./button-state-icon-template.html'),
        scope: {
            onClick: '&',
            currentState: '='
        },
        link(scope, element, attr) {
            attr.$observe('states', (value) => {
                // E.g. of the expected states array:
                // [{ loading: { label: 'Loading...' } }, 'loading': { ... }, 'loaded', {...}]
                if (value) {
                    const cleanUp = value.replace(/'/g, '"');
                    scope.states = angular.fromJson(cleanUp);
                }
            });
        }
    };
}

module.exports = ButtonLoadIconDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/button-state-icon/button-state-icon-directive.js
 **/